import { Location } from 'history';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ELSWithModalService } from '@els/els-component-modal-react';
import { ELSModalServiceType } from 'models/els';
import { routerSelectors } from 'redux/ducks/route';

interface LocationChangeHandlerProps {
  location: Location;
  modalService: ELSModalServiceType;
}

class LocationChangeHandler extends Component<LocationChangeHandlerProps> {
  componentDidUpdate({ location }) {
    const pathname = 'pathname';
    if (location && this.props.location && location[pathname] !== this.props.location[pathname]) {
      this.props.modalService.closeAllModal();
    }
    /* eslint-disable no-underscore-dangle */
    window._mfq = window._mfq || [];
    const regexp = /\/#/g;
    const href = window.location.href.replace(regexp, '');
    window._mfq.push(['newPageView', href]);
  }

  render() {
    return null;
  }
}

const mapStateToProps = createStructuredSelector({
  location: routerSelectors.getLocation
});

export default connect(mapStateToProps)(ELSWithModalService(LocationChangeHandler));
